<template>
    <div id="left-bar-distribution">
        <ul>
            <li class="menu-title text-center">
                <i class="fa fa-shopping-bag mr-2"/>
                <span v-html="$t('LeftBarDistribution.distribution')"/>
            </li>
            <li class="has_sub active">
                <router-link to="/distribution/dashboard" class="waves-effect" :class="{ active: this.$route.name === 'distribution-dashboard' }">
                    <i class="fa fa-chart-line"/>
                    <span v-html="$t('LeftBarDistribution.dashboard')"/>
                </router-link>
            </li>
            <li class="has_sub">
                <router-link to="/distribution/orders" class="waves-effect" :class="{ active: this.$route.name === 'distribution-orders' }">
                    <i class="fa fa-boxes"/>
                    <span v-html="$t('LeftBarDistribution.orders')"/>
                </router-link>
            </li>
            <li class="has_sub">
                <router-link to="/distribution/booksellers" class="waves-effect" :class="{ active: this.$route.name === 'booksellers' }">
                    <i class="fa fa-users"/>
                    <span v-html="$t('LeftBarDistribution.booksellers')"/>
                </router-link>
            </li>
            <li class="has_sub">
                <router-link to="/distribution/withdrawal-points" class="waves-effect" :class="{ active: this.$route.name === 'withdrawal-points' }">
                    <i class="fas fa-store"/>
                    <span v-html="$t('LeftBarDistribution.withdrawalPoints')"/>
                </router-link>
            </li>
        </ul>
        <div class="clearfix"/>
    </div>
</template>

<script>
export default {
    name: "LeftBarDistribution",
};
</script>

<style lang="scss">
    @import "../../../assets/scss/colors";

    #left-bar-distribution {
        .waves-effect {
            &.active {
                border-left-color: $distribution-color;
                i {
                    color: $distribution-color;
                }
            }
            .waves-ripple {
                background-color: rgba($distribution-color, 0.45) !important;
            }
        }
    }
</style>